import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
type tab = {
    key: number;
    name: string;
    imgPath: string;
    content: {
        id: number;
        usageTime: string;
        timeUnit: string;
        power: string;
        useScenes: string;
        desc: string;
    }[];
};

type config = {
    globalWidth: string;
    tabColor: string;
    tabActiveColor: string;
    lineColor: string;
    cardItemWidth: string;
    cardMarginRight: string;
    cardItemBg: string;
    usageTimeColor: string;
    timeUnitColor: string;
};

type params = {
    tabs: tab[];
    config: config;
};

const tabsDefault: tab[] = [
    {
        key: 1,
        name: '1260Wh',
        imgPath: '/img/productDetails/delta/1260Wh.png',
        content: [
            {
                id: 0,
                power: '120W/hr',
                useScenes: 'Family Daily Use',
                desc: 'Live in total comfort',
                usageTime: '10.5',
                timeUnit: 'Hrs',
            },
            {
                id: 1,
                power: '153W/Hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone+refrigerator/freezer',
                usageTime: '8',
                timeUnit: 'Hrs',
            },
            {
                id: 2,
                power: '78W/hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone',
                usageTime: '16',
                timeUnit: 'Hrs',
            },
        ],
    },
    {
        key: 2,
        name: '2520Wh',
        imgPath: '/img/productDetails/delta/2520Wh.png',
        content: [
            {
                id: 0,
                power: '120W/hr',
                useScenes: 'Family Daily Use',
                desc: 'Live in total comfort',
                usageTime: '21',
                timeUnit: 'Hrs',
            },
            {
                id: 1,
                power: '153W/Hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone+refrigerator/freezer',
                usageTime: '16',
                timeUnit: 'Hrs',
            },
            {
                id: 2,
                power: '78W/hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone',
                usageTime: '32',
                timeUnit: 'Hrs',
            },
        ],
    },
    {
        key: 3,
        name: '3780Wh',
        imgPath: '/img/productDetails/delta/3780Wh.png',
        content: [
            {
                id: 0,
                power: '120W/hr',
                useScenes: 'Family Daily Use',
                desc: 'Live in total comfort',
                usageTime: '31.5',
                timeUnit: 'Hrs',
            },
            {
                id: 1,
                power: '153W/Hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone+refrigerator/freezer',
                usageTime: '24',
                timeUnit: 'Hrs',
            },
            {
                id: 2,
                power: '78W/hr',
                useScenes: 'Emergency Use',
                desc: '4 lights、fan、router、laptop、charging for smart phone',
                usageTime: '48',
                timeUnit: 'Hrs',
            },
        ],
    },
];

const defaultConfig: config = {
    globalWidth: '820px',
    tabColor: '',
    tabActiveColor: '',
    lineColor: '',
    cardItemWidth: '260px',
    cardMarginRight: '20px',
    cardItemBg: '',
    usageTimeColor: '#fff',
    timeUnitColor: '#fff',
};

export default function TabInfo({ tabs = tabsDefault, config = defaultConfig }: params) {
    const { useState } = useGlobal();

    const [tabPosition, setTabPosition] = useState({
        tabWidth: 132,
        offsetLeft: 70,
    });
    const [tabIndex, setTabIndex] = useState(1);

    const changeTabIndex = (e: any) => {
        const index = e.target.dataset.index;
        const { clientWidth, offsetLeft } = e.target;
        setTabIndex(Number(index));
        setTabPosition({ tabWidth: clientWidth, offsetLeft: offsetLeft });
        e.preventDefault();
    };
    return (
        <>
            <div className={css.tab_info} style={{ width: config.globalWidth }}>
                <div className="tab_info_img">
                    {tabs.map((tab, index) => (
                        <div className={`imgItem ${index + 1 === tabIndex ? 'show' : 'hide'}`} key={index}>
                            <Image src={tab.imgPath} alt={tab.name} width={1920} height={1080} />
                        </div>
                    ))}
                </div>

                <div className="tabsPanel">
                    <div className="tabs">
                        {tabs.map((tab: tab) => (
                            <div key={tab.key} className={`font-family-bold tab ${tab.key === tabIndex ? 'select' : ''}`}>
                                <a href="#" data-index={tab.key} onClick={changeTabIndex} aria-label={tab.name}>
                                    {tab.name}
                                </a>
                            </div>
                        ))}
                    </div>
                    <div
                        className="line"
                        style={{
                            width: `calc(${tabPosition.tabWidth}px)`,
                            left: `calc(${tabPosition.offsetLeft}px)`,
                        }}
                    ></div>
                </div>

                <div className="content">
                    {tabs
                        .find((tab: tab) => tab.key === tabIndex)
                        ?.content.map((card, i) => (
                            <div
                                className="cardItem font-family-bold"
                                style={{
                                    width: config.cardItemWidth,
                                    marginRight: config.cardMarginRight,
                                }}
                                key={i}
                            >
                                <h3 className="useScenes">{card.useScenes}</h3>
                                <div className="power">{card.power}</div>
                                <p className="desc font-family-semibold">{card.desc}</p>
                                <div className="usage">
                                    <span style={{ color: config.usageTimeColor }} className="usageTime">
                                        {card.usageTime}
                                    </span>
                                    <span style={{ color: config.timeUnitColor }} className="timeUnit">
                                        {card.timeUnit}
                                    </span>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
}
